import {activeMatchmakingMatchTypes} from '../../../shared/matchmaking/MatchmakingEnums'
import {UIUrlParameterNames} from '../../shared/scripts/ui_html/UIUrlController'
import {UIEntryUrlParameterController} from '../../shared/scripts/UIEntryUrlParameterController'
import {uiManager} from './EntryMobile'
import {clientIntl} from '../../shared/scripts/ClientI18n'
import {SocketLobbySend} from '../../shared/scripts/socket/SocketLobbySend'
import {UIMSceneEnum} from '../../../shared/enums/UIMSceneEnums'
import {MatchmakingMatchTypes} from '@colonist/game-base-types'

export class EntryMobileUrlParameterController extends UIEntryUrlParameterController {
    static loadParameterEvents() {
        const urlParams = new URLSearchParams(window.location.hash.replace(/^#/, ''))
        for(const parameterName of urlParams.keys()) {
            const parameterValue = urlParams.get(parameterName)
            if(parameterValue == null) continue
            switch(parameterName as UIUrlParameterNames) {
                case UIUrlParameterNames.MobileLeaderboard: this.loadScene(UIMSceneEnum.Leaderboard); this.removeParameter(); break
                case UIUrlParameterNames.MobileLobby: this.loadScene(UIMSceneEnum.Lobby); this.removeParameter(); break
                case UIUrlParameterNames.MobileHomepage: this.loadScene(UIMSceneEnum.Homepage); this.removeParameter(); break
                case UIUrlParameterNames.MobileStore: this.loadScene(UIMSceneEnum.Store); this.removeParameter(); break
                case UIUrlParameterNames.MobileProfile: this.loadScene(UIMSceneEnum.Profile); this.removeParameter(); break
                case UIUrlParameterNames.Campaign: this.loadCampaignMode(parameterValue); this.removeParameter(); break
                case UIUrlParameterNames.EnterMatchmaking: this.loadMatchmakingQueue(parameterValue); this.removeParameter(); break
                default: break
            }
        }
    }

    static removeParameter() {
        const pathPrefix = clientIntl.getLanguagePathPrefix() || ''
        const url = pathPrefix + '/mobile'
        window.history.replaceState({}, document.title, url)
    }

    static loadScene(scene: UIMSceneEnum) {
        uiManager.sceneController.loadScene(scene)
    }

    static loadCampaignMode(parameter: string) {
        if(parameter != this.DEFAULT_PARAMETER_VALUE) return

        void SocketLobbySend.continueCampaignMode()
    }

    static loadMatchmakingQueue(parameter: string) {
        const matchType = Number(parameter)
        if(!activeMatchmakingMatchTypes.has(matchType)) return
        void uiManager.mainpageController.bodyController.homepageController.matchmakingController.startGame(matchType as MatchmakingMatchTypes)
    }
}
